import React from 'react';
import { Trans } from '@lingui/macro';
import { FormattedMarkdown } from '@qover/react-intl';

export default {
  yourPolicyDocuments: (
    <Trans
      id="confirmation.yourPolicyDocuments"
      defaults="Your policy documents"
    />
  ),
  pleaseFindYourPolicy: (
    <Trans
      id="confirmation.pleaseFindYourPolicy"
      defaults="Please find your policy documents below:"
    />
  ),
  yourPolicySchedule: (policyholderEmail: string) => (
    <Trans
      id="confirmation.yourPolicySchedule"
      defaults="Your policy schedule and general policy conditions were also send to the following email address ({email})."
      values={{
        email: (
          <strong data-test="confirmation.policyholderEmail">
            {policyholderEmail}
          </strong>
        ),
      }}
    />
  ),
  feelFreeToContactUs: (
    <FormattedMarkdown
      data-test="confirmation.contactUs"
      defaults="Feel free to contact us for any remaining question."
      id="confirmation.feelFreeToContactUs"
      options={{ forceBlock: true }}
    />
  ),
  download: <Trans id="general.download" defaults="Download" />,
};
